import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Sparkles } from 'lucide-react';
import img from '../assets/handShake.avif'
import { useTranslation } from 'react-i18next';

const WhyChooseUs = () => {
  const { t } = useTranslation();
  const reasons = t('whyChooseUs.reasons', { returnObjects: true }) || [];

  return (
    <section className="py-5" style={{ backgroundColor: 'var(--color-bg)' }}>
      <Container className="py-5">
        <Row className="align-items-center">
          <Col lg={6} data-aos="fade-right">
            <div
              className="position-relative"
              style={{ height: "400px", overflow: "hidden", borderRadius: "12px" }}
            >
              <img
                src={img}
                alt="Craftsmanship"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover"
                }}
              />
            </div>
          </Col>
          <Col lg={6} className="mb-5 mb-lg-0 pe-lg-5" data-aos="fade-left" data-aos-delay="200">
            <h6 className="text-uppercase mb-3" style={{ color: 'var(--color-accent)', letterSpacing: '2px', fontWeight: 'bold' }}>
              {t('whyChooseUs.subtitle')}
            </h6>
            <h2 className="display-4 fw-bold text-dark mb-4" style={{ fontFamily: 'var(--font-serif)' }}>
              {t('whyChooseUs.title')}
            </h2>
            <div style={{ width: '60px', height: '3px', backgroundColor: 'var(--color-accent)' }} className="mb-5"></div>
            
            <Row className="g-4">
              {Array.isArray(reasons) && reasons.map((reason, index) => (
                 <Col sm={6} key={index} data-aos="fade-up" data-aos-delay={`${200 + index * 100}`}>
                    <div className="d-flex align-items-start gap-3">
                      <Sparkles size={20} color="var(--color-accent)" className="flex-shrink-0 mt-1" />
                      <p className="text-dark opacity-75 mb-0" style={{ lineHeight: '1.6' }}>{reason}</p>
                    </div>
                 </Col>
              ))}
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default WhyChooseUs;
